'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FactboxText = exports.FactboxSubtitle = exports.FactboxSubheading = exports.FactboxList = exports.FactboxLead = exports.FactboxHeadline = exports.FactboxBlockquote = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _pick2 = require('lodash/pick');

var _pick3 = _interopRequireDefault(_pick2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _hocExpandable = require('@spp/hoc-expandable');

var _hocExpandable2 = _interopRequireDefault(_hocExpandable);

var _uiBlockquote = require('@spp/ui-blockquote');

var _uiHeadline = require('@spp/ui-headline');

var _uiLeadText = require('@spp/ui-lead-text');

var _uiList = require('@spp/ui-list');

var _uiSubheading = require('@spp/ui-subheading');

var _uiSubtitle = require('@spp/ui-subtitle');

var _uiText = require('@spp/ui-text');

var _themeProvider = require('@spp/theme-provider');

var _Factbox = require('./Factbox');

var _Factbox2 = _interopRequireDefault(_Factbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ExpandableFactbox = (0, _hocExpandable2.default)()(_Factbox2.default);

var FactboxBlockquote = (0, _themeProvider.themer)('@spp/ui-factbox:blockquote')(_uiBlockquote.Blockquote);
var FactboxHeadline = (0, _themeProvider.themer)('@spp/ui-factbox:headline')(_uiHeadline.Headline);
var FactboxLead = (0, _themeProvider.themer)('@spp/ui-factbox:lead')(_uiLeadText.LeadText);
var FactboxList = (0, _themeProvider.themer)('@spp/ui-factbox:list')(_uiList.List);
var FactboxSubheading = (0, _themeProvider.themer)('@spp/ui-factbox:subheading')(_uiSubheading.Subheading);
var FactboxSubtitle = (0, _themeProvider.themer)('@spp/ui-factbox:subtitle')(_uiSubtitle.Subtitle);
var FactboxText = (0, _themeProvider.themer)('@spp/ui-factbox:text')(_uiText.Text);

ExpandableFactbox.propTypes = (0, _extends3.default)({}, (0, _pick3.default)(_Factbox2.default.propTypes, ['title', 'children', 'theme', 'expandBy']), {
    expanded: _propTypes2.default.bool,
    interaction: _propTypes2.default.func
});
ExpandableFactbox.defaultProps = {
    expanded: false,
    interaction: function interaction() {}
};

exports.FactboxBlockquote = FactboxBlockquote;
exports.FactboxHeadline = FactboxHeadline;
exports.FactboxLead = FactboxLead;
exports.FactboxList = FactboxList;
exports.FactboxSubheading = FactboxSubheading;
exports.FactboxSubtitle = FactboxSubtitle;
exports.FactboxText = FactboxText;
exports.default = (0, _themeProvider.themer)('@spp/ui-factbox')(ExpandableFactbox);
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/hyperion-web-components/~/@spp/ui-factbox/lib/cjs/index.js
 ** module id = 516
 ** module chunks = 1
 **/